<template>
	<div>
		<case-form :schema="caseSchema" class="mt4" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "SHProposalOverview",
	components: { CaseForm },
	data() {
		return {
			caseSchema: [
				{
					label: "Currency Code",
					component: "select",
					bindTo: "case.facts.currencyCode",
					props: {
						options: [
							{
								name: "Hong Kong Dollar",
								value: "HKD"
							}
						]
					}
				},
				{
					label: "Sign Date",
					component: "date",
					dataType: "date",
					bindTo: "case.facts.signDate"
				}
			]
		}
	}
}
</script>
